import _Vue from 'vue';

const map = new Map();
map.set('homeTitle',
{
    sv: 'Moominhouse',
    en: 'Moominhouse',
    fi: 'Moominhouseen',
    no: 'Moominhouse'
});
map.set('homeSubTitle',
{
    sv: 'Skapad av samlare för samlare',
    en: 'Created by collectors for collectors',
    fi: 'Keräilijöiden luoma keräilijöille',
    no: 'Laget av samler for samler'
});
map.set('moominProductsTitle',
{
    sv: 'Muminmuggar',
    en: 'Moominprodukts',
    fi: 'Muumituotteet',
    no: 'Mummikopper'
});
map.set('moominProductsSubTitle',
{
    sv: 'Här kan du lägga till de muggar som du har hemma i din samling för att enkelt se vilka du saknar. Du kan också spara dina favoriter som du tycker extra mycket om eller som du önskar dig genom att trycka på hjärtat.',
    en: 'The complete site for moomin mugs',
    fi: 'Täällä voit merkitä mukit, jotka kuuluvat jo kokoelmaasi. Näin näet helposti, mitkä mukit sinulta puuttuvat. Voit myös merkitä suosikkisi tai toivomasi mukit sydämellä.',
    no: 'Her kan du legge til krusene du har hjemme i samlingen din for enkelt å se hvilke du mangler. Du kan også lagre favorittene dine som du virkelig liker eller som du vil ha ved å trykke på hjertet.'
});
map.set('characterTitle',
{
    sv: 'Karaktärer i Mumindalen',
    en: 'Characters in Moominvalley',
    fi: 'Muumilaakson hahmoja',
    no: 'Karakterer i Mummidalen'
});
map.set('characterSubTitle',
{
    sv: 'Lär känna muminfamiljen med vänner närmare. Här finner du välkända ansikten som bor i Muminhuset och kanske några nya ansikten som vi träffar på mer sällan. Klicka på bilden med den karaktär du vill läsa mer om, vem vet, kanske du hittar en ny favorit?',
    en: 'This is us',
    fi: 'Opi tuntemaan muumiperhe. Täältä löydät tunnetut Muumitalon asukkaat sekä vähemmän tunnetut Muumilaakson hahmot. Kuvaa klikkaamalla voit lukea hahmosta lisää ja kuka tietää, ehkä löydät uuden suosikin.',
    no: 'Bli nærmere kjent med Mummi-familien med venner. Her finner du kjente fjes som bor i Mummihuset og kanskje noen nye fjes som vi møter sjeldnere. Klikk på bildet med karakteren du vil lese mer om, hvem vet, kanskje finner du en ny favoritt?'
});
map.set('collectionTitle',
{
    sv: 'Min samling',
    en: 'My collection',
    fi: 'Minun kokoelma',
    no: 'Min samling'
});
map.set('collectionSubTitle1',
{
    sv: 'Du har inte lagt till något i din samling',
    en: 'Nothing in your Collection',
    fi: 'Kokoelmasi on tyhjä',
    no: 'Du har ikke lagt til noe i samlingen din'
});
map.set('collectionSubTitle2',
{
    sv: 'Här kan du spara alla dina muminmuggar och få ett estimerat värde av din samling.',
    en: 'Here you can save all your Moomin mugs and get an estimated value of your collection.',
    fi: 'Täällä voit tallentaa kaikki Muumimukisi ja saada arvion kokoelmasi arvosta.',
    no: 'Her kan du lagre alle mummikrusene dine og få en estimert verdi fra samlingen din.'
});
map.set('collectionSubTitle3',
{
    sv: 'Klicka här för att köpa fler muminmuggar till er samling.',
    en: 'Click here to buy more mugs for your collection.',
    fi: 'Klikkaa tästä ostaaksesi lisää muumimukeja.',
    no: 'Klikk her for å kjøpe flere mummikrus til samlingen din.'
});
map.set('signIn1',
{
    sv: 'Du måste ',
    en: 'You need to ',
    fi: 'Kirjaudu ',
    no: 'Du må '
});
map.set('signIn2',
{
    sv: 'logga in',
    en: 'sign in',
    fi: 'sisään,',
    no: 'logge inn'
});
map.set('signIn3',
{
    sv: ' för att spara din samling och få ett estimerat värde av din samling',
    en: ' to save to your collection and get an estimated value of your collection',
    fi: ' jotta pystyt tallentamaan kokoelmasi',
    no: ' for å lagre samlingen din og få en estimert verdi av samlingen din'
});
map.set('collectionToAdd',
{
    sv: 'Klicka här för att lägga till',
    en: 'Click to add',
    fi: 'Klikkaa tästä lisätäksesi',
    no: 'Klikk her for å legge til'
});
map.set('collectionLinkDoesNotWork',
{
    sv: 'Länken fungerar inte',
    en: 'The link doesn\'t work',
    fi: 'Linkki ei toimi',
    no: 'Linken fungerer ikke'
});
map.set('collectionDependsOn',
{
    sv: 'Det beror antagligen på att användaren inte vill dela sin samling längre eller har skapat en ny länk.',
    en: 'It probablt depends on that the user doesn\'t want to share the collection any more, or has created a new link',
    fi: 'Luultavasti käyttäjä ei halua jakaa kokoelmaansa tai hän on luonut uuden linkin.',
    no: 'Dette er sannsynligvis fordi brukeren ikke lenger ønsker å dele samlingen sin eller har opprettet en ny lenke.'
});
map.set('collectionSharedWithYou',
{
    sv: 'Den här samlingen är delad med dig',
    en: 'This collection is shared with you',
    fi: 'Tämä kokoelma on jaettu kanssasi',
    no: 'Denne samlingen er delt med deg'
});
map.set('collectionShareCollection',
{
    sv: 'Dela din samling',
    en: 'Share your collection',
    fi: 'Jaa kokoelmani',
    no: 'Del samlingen din'
});
map.set('collectionGetLink',
{
    sv: 'Få länk',
    en: 'Get link',
    fi: 'Tilaa linkki',
    no: 'Få lenken'
});
map.set('collectionAll',
{
    sv: 'Alla',
    en: 'All',
    fi: 'Kaikki',
    no: 'Alle'
});
map.set('collectionCollected',
{
    sv: 'Samlade',
    en: 'Collected',
    fi: 'Kerätyt',
    no: 'Samlet'
});
map.set('collectionRemainingToCollect',
{
    sv: 'Kvar att samla',
    en: 'Remaining to collect',
    fi: 'Keräämättä',
    no: 'Gjenstår å samle'
});
map.set('yes',
{
    sv: 'Ja',
    en: 'Yes',
    fi: 'Kyllä',
    no: 'Ja'
});
map.set('no',
{
    sv: 'Nej',
    en: 'No',
    fi: 'Ei',
    no: 'Nei'
});
map.set('thankYou',
{
    sv: 'Tack',
    en: 'Thank you',
    fi: 'Kiitos',
    no: 'Takk'
});
map.set('likesTitle',
{
    sv: 'Dina favoriter',
    en: 'Your favorites',
    fi: 'Suosikkisi',
    no: 'Dine favoritter'
});
map.set('likesSubTitle1',
{
    sv: 'Du har inte valt några favoriter',
    en: 'You haven\'t liked anything',
    fi: 'Sinä et ole valinnut suosikkeja',
    no: 'Du har ikke valgt noen favoritter'
});
map.set('likesSubTitle2',
{
    sv: 'Detta är alla produkter som du har givit ett hjärta',
    en: 'These are all products that you have hearted',
    fi: 'Kaikki tuotteet, joista olet tykännyt',
    no: 'Dette er alle produkter du har gitt et hjerte'
});
map.set('orderTitle',
{
    sv: 'Det här är dina ordrar',
    en: 'This is your Orders',
    fi: 'Nämä ovat tilauksesi',
    no: 'Dette er dine bestillinger'
});
map.set('orderSubTitle',
{
    sv: 'Du har inte lagt några ordrar',
    en: 'You haven\'t ordered anything',
    fi: 'Sinä et ole tehnyt tilausta',
    no: 'Du har ikke lagt inn noen bestillinger'
});
map.set('orderId',
{
    sv: 'Orderid',
    en: 'Order Id',
    fi: 'Tilaustunnus',
    no: 'Orderid'
});
map.set('orderDate',
{
    sv: 'Orderdatum',
    en: 'Order Date',
    fi: 'Tilauspäivämäärä',
    no: 'Bestillingsdato'
});
map.set('ShoppingCartTitle',
{
    sv: 'Kundvagn',
    en: 'Shopping Cart',
    fi: 'Ostoskori',
    no: 'Handlevogn'
});
map.set('ShoppingCartSubTitle',
{
    sv: 'Du har inget i din kundvagn',
    en: 'Nothing in your Shopping Cart',
    fi: 'Ostoskorisi on tyhjä',
    no: 'Du har ingenting i handlekurven'
});
map.set('mobile',
{
    sv: 'Mobilnummer',
    en: 'Mobile Number',
    fi: 'Kännykkänumero',
    no: 'Mobilnummer'
});
map.set('completeOrder',
{
    sv: 'Bekräfta Order',
    en: 'Complete Order',
    fi: 'Vahvista tilaus',
    no: 'Bekreft ordre'
});
map.set('needToSignIn',
{
    sv: 'Logga in för att fortsätta',
    en: 'Sign in to continue',
    fi: 'Kirjaudu sisään jatkaaksesi',
    no: 'Logg på for å fortsette'
});
map.set('SignInTitle',
{
    sv: 'Logga In',
    en: 'Sign In',
    fi: 'Kirjaudu sisään',
    no: 'Logg inn'
});
map.set('SignInSubTitle',
{
    sv: 'Så att du kan spara din samling',
    en: 'To be able to save your collection',
    fi: 'Jotta voit tallentaa kokoelmasi',
    no: 'Så du kan lagre samlingen din'
});
map.set('email',
{
    sv: 'E-post',
    en: 'E-mail',
    fi: 'Sähköposti',
    no: 'E-post'
});
map.set('yourEmail',
{
    sv: 'Din E-post',
    en: 'Your E-mail',
    fi: 'Sinun sähköpostisi',
    no: 'Din E-post'
});
map.set('password',
{
    sv: 'Lösenord',
    en: 'Password',
    fi: 'Salasana',
    no: 'Passord'
});
map.set('yourPassword',
{
    sv: 'Ditt lösenord',
    en: 'Your password',
    fi: 'Sinun salasanasi',
    no: 'Ditt passord'
});
map.set('signUp',
{
    sv: 'Bli medlem',
    en: 'Sign Up',
    fi: 'Uusi käyttäjä',
    no: 'Melde deg på'
});
map.set('signUpMoominhouse',
{
    sv: 'Bli medlem på Moominhouse.',
    en: 'Sign Up on Moominhouse',
    fi: 'Uusi käyttäjä päällä Moominhouse',
    no: 'Bli medlem på Moominhouse.'
});
map.set('whoYouLike',
{
    sv: 'Är du osäker på vem du är mest lik?',
    en: 'Unsure who your character are?',
    fi: 'Etkö tiedä, mitä hahmoa muistutat eniten?',
    no: 'Er du usikker på hvem du ligner mest på?'
});
map.set('officialCharacterTest',
{
    sv: 'Ta mumins officiella karaktärstest!',
    en: 'Take the official Moomin test!',
    fi: 'Tee muumihahmotesti!',
    no: 'Ta mummins offisielle karaktertest'
});
map.set('staySignedIn',
{
    sv: 'Håll mig inloggad',
    en: 'Keep me singed in',
    fi: 'Pidä minut sisäänkirjautuneena',
    no: 'Hold meg pålogget'
});
map.set('ResetPasswordTitle',
{
    sv: 'Återställ ert lösenord',
    en: 'Reset your password',
    fi: 'Unohtuiko salasanasi?',
    no: 'Tilbakestill passordet ditt'
});
map.set('ResetPasswordSubTitle',
{
    sv: 'Återställ om ni har glömt ert lösenord',
    en: 'Reset if you have forgotten your password',
    fi: 'Unohtuiko salasanasi?',
    no: 'Tilbakestill hvis du har glemt passordet'
});
map.set('ResetPassword',
{
    sv: 'Återställ lösenordet',
    en: 'Reset password',
    fi: 'Korjaa salasana',
    no: 'Tilbakestill passordet'
});
map.set('ForgotPassword',
{
    sv: 'Glömt lösenordet?',
    en: 'Forgot password?',
    fi: 'Unohditko salasanan?',
    no: 'Glemt passordet?'
});
map.set('SignUpTitle',
{
    sv: 'Bli medlem',
    en: 'Become a member',
    fi: 'Liity jäseneksi',
    no: 'Bli medlem'
});
map.set('SignUpSubTitle',
{
    sv: 'Du kan då börja fylla i din samling',
    en: 'Get possibiblity to save your collection',
    fi: 'Voit alkaa kerätä mukeja kokoelmaasi',
    no: 'Du kan deretter begynne å fylle ut samlingen din'
});
map.set('name',
{
    sv: 'Namn',
    en: 'Name',
    fi: 'Nimi',
    no: 'Navn'
});
map.set('firstName',
{
    sv: 'Förnamn',
    en: 'First name',
    fi: 'Etunimi',
    no: 'Fornavn'
});
map.set('lastName',
{
    sv: 'Efternamn',
    en: 'Last name',
    fi: 'Sukunimi',
    no: 'Etternavn'
});
map.set('yourPasswordAgain',
{
    sv: 'Ditt lösenord igen',
    en: 'Your password again',
    fi: 'Vahvista salasana',
    no: 'Passordet ditt igjen'
});
map.set('yourCharacter',
{
    sv: 'Din karaktär',
    en: 'Your character',
    fi: 'Sinun hahmosi',
    no: 'Din karakter'
});
map.set('becomeMember',
{
    sv: 'Bli en medlem',
    en: 'Become a member',
    fi: 'Liity jäseneksi',
    no: 'Bli en medlem'
});
map.set('alreadyMember',
{
    sv: 'Redan en medlem?',
    en: 'Already a member?',
    fi: 'Oletko jo jäsen?',
    no: 'Allerede medlem?'
});
map.set('validateTitle',
{
    sv: 'Validering',
    en: 'Validation',
    fi: 'Vahvistaminen',
    no: 'Validering'
});
map.set('validateSubTitle',
{
    sv: 'Här kan du validera din e-mail med den valideringskod som skickades till din mail',
    en: 'Here you can validate your e-mail with the validation code that was sent to your mail',
    fi: 'Voit vahvistaa sähköpostiosoitteesi vahvistuskoodilla, joka on lähetetty sähköpostiisi',
    no: 'Her kan du validere din e-post med valideringskoden som ble sendt til din e-post'
});
map.set('validationCode',
{
    sv: 'Valideringskod',
    en: 'Validation Code',
    fi: 'Vahvistuskoodi',
    no: 'Valideringskode'
});
map.set('validate',
{
    sv: 'Validera',
    en: 'Validate',
    fi: 'Vahvista',
    no: 'Validere'
});
map.set('missingValidationCode',
{
    sv: 'Måste ange valideringskod',
    en: 'Need to provide validation code',
    fi: 'Syötä vahvistuskoodi',
    no: 'Må oppgi valideringskode'
});
map.set('emailValidated',
{
    sv: 'E-post validerad!',
    en: 'Email validated!',
    fi: 'Sähköposti vahvistettu',
    no: 'E-post validert'
});
map.set('thanksAndWelcome',
{
    sv: 'Tack! Välkommen att använda vår sida',
    en: 'Thanks! Welcome to use our site',
    fi: 'Kiitos! Tervetuloa käyttämään sivuamme',
    no: 'Takk! Velkommen til å bruke siden vår'
});
map.set('canNowSignIn',
{
    sv: 'Ni kan nu logga in på ert konto',
    en: 'You can now sign in',
    fi: 'Nyt voit kirjautua sisään',
    no: 'Du kan nå logge på kontoen din'
});
map.set('here',
{
    sv: 'här',
    en: 'here',
    fi: 'tästä',
    no: 'her'
});
map.set('missingEmail',
{
    sv: 'Måste ange e-post',
    en: 'Need to provide email',
    fi: 'Kirjoita sähköposti',
    no: 'Må oppgi e-post'
});
map.set('missingPassword',
{
    sv: 'Måste ange lösenord',
    en: 'Need to provide password',
    fi: 'Kirjoita salasana',
    no: 'Må oppgi passord'
});
map.set('wrongEmailOrPassword',
{
    sv: 'Fel e-post eller lösenord',
    en: 'Wrong email or password',
    fi: 'Väärä sähköposti tai salasana',
    no: 'Feil e-post eller passord'
});
map.set('errorSignIn',
{
    sv: 'Något gick fel vid inloggning',
    en: 'Error signing in',
    fi: 'Jotain meni väärin sisäänkirjaitumisessa',
    no: 'Noe gikk galt under pålogging'
});
map.set('wrongCode',
{
    sv: 'Felaktig kod',
    en: 'Wrong code',
    fi: 'Väärä koodi',
    no: 'Feil kode'
});
map.set('ShippingTitle',
{
    sv: 'Fraktalternativ',
    en: 'Shipping',
    fi: 'Kuljetusvaihtoehdot',
    no: 'Fraktalternativer'
});
map.set('ShippingSubTitle',
{
    sv: 'Välj ett fraktalternativ',
    en: 'Decide on shipping',
    fi: 'Valitse yksi kuljetusvaihtoehto',
    no: 'Velg et fraktalternativ'
});
map.set('delivery',
{
    sv: 'Leverans',
    en: 'Delivery',
    fi: 'Toimitus',
    no: 'Leveranse'
});
map.set('country',
{
    sv: 'Land',
    en: 'Country',
    fi: 'Maa',
    no: 'Land'
});
map.set('PaymentTitle',
{
    sv: 'Betalning',
    en: 'Payment',
    fi: 'Maksaminen',
    no: 'Betaling'
});
map.set('PaymentSubTitle',
{
    sv: 'Välj betalningsmetod',
    en: 'Decide on payment',
    fi: 'Valitse maksutapa',
    no: 'Velge betalingsmetode'
});
map.set('payment-method',
{
    sv: 'Betalningsmetod',
    en: 'Payment method',
    fi: 'Maksutapa',
    no: 'Betalingsmetode'
});
map.set('quantity',
{
    sv: 'Antal',
    en: 'Quantity',
    fi: 'Lukumäärä',
    no: 'Mengde'
});
map.set('price',
{
    sv: 'Pris',
    en: 'Price',
    fi: 'Hinta',
    no: 'Tildele'
});
map.set('discount',
{
    sv: 'Rabatt',
    en: 'Discount',
    fi: 'Alennus',
    no: 'Rabatt'
});
map.set('total',
{
    sv: 'Totalt',
    en: 'Total',
    fi: 'Yhteensä',
    no: 'Totalt'
});
map.set('shoppingCart',
{
    sv: 'Kundvagn',
    en: 'Shopping Cart',
    fi: 'Ostoskori',
    no: 'Handlevogn'
});
map.set('collection',
{
    sv: 'Min Samling',
    en: 'My Collection',
    fi: 'Kokoelmani',
    no: 'Min samling'
});
map.set('likes',
{
    sv: 'Mina favoriter',
    en: 'My favorites',
    fi: 'Suosikkini',
    no: 'Mine favoritter'
});
map.set('home',
{
    sv: 'Hem',
    en: 'Home',
    fi: 'Koti',
    no: 'Hjem'
});
map.set('products',
{
    sv: 'Muminmuggar',
    en: 'Product info',
    fi: 'Muumimukit',
    no: 'Mummikrus'
});
map.set('shop',
{
    sv: 'Shop',
    en: 'Shop',
    fi: 'Kauppa',
    no: 'Butikk'
});
map.set('characters',
{
    sv: 'Karaktärer',
    en: 'Characters',
    fi: 'Hahmot',
    no: 'Karakterer'
});
map.set('myPage',
{
    sv: 'Min Sida',
    en: 'My Page',
    fi: 'Minun Sivuni',
    no: 'Min side'
});
map.set('profile',
{
    sv: 'Min Profil',
    en: 'My Profile',
    fi: 'Profiilini',
    no: 'Min Profil'
});
map.set('orders',
{
    sv: 'Mina Ordrar',
    en: 'My Orders',
    fi: 'Tilaukseni',
    no: 'Mine bestillinger'
});
map.set('signIn',
{
    sv: 'Logga In',
    en: 'Sign In',
    fi: 'Kirjaudu sisään',
    no: 'Logg inn'
});
map.set('signInOnMoominhouse',
{
    sv: 'Logga In på Moominhouse',
    en: 'Sign In on Moominhouse',
    fi: 'Kirjaudu sisään päällä Moominhouse',
    no: 'Logg inn på Moominhouse'
});
map.set('signOut',
{
    sv: 'Logga Ut',
    en: 'Sign Out',
    fi: 'Kirjaudu ulos',
    no: 'Logg ut'
});
map.set('language',
{
    sv: 'Språk',
    en: 'Language',
    fi: 'Kieli',
    no: 'Språk'
});
map.set('ContactTitle',
{
    sv: 'Kontaktinformation',
    en: 'Contact Information',
    fi: 'Yhteystiedot',
    no: 'Kontaktinformasjon'
});
map.set('ContactSubTitle',
{
    sv: 'Leverans och fakturaadress',
    en: 'Shipping and billing information',
    fi: 'Kuljetus ja laskutusosoite',
    no: 'Leverings- og fakturaadresse'
});
map.set('AddressTitle',
{
    sv: 'Adress',
    en: 'Address',
    fi: 'Osoite',
    no: 'Adresse'
});
map.set('co',
{
    sv: 'C/O'
});
map.set('address',
{
    sv: 'Adress',
    en: 'Address',
    fi: 'Osoite',
    no: 'Adresse'
});
map.set('streetAddress',
{
    sv: 'Gatuadress',
    en: 'Street address',
    fi: 'Katuosoite',
    no: 'Gateadresse'
});
map.set('postalCode',
{
    sv: 'Postkod',
    en: 'Postal Code',
    fi: 'Postinumero',
    no: 'Postnummer'
});
map.set('city',
{
    sv: 'Stad',
    en: 'City',
    fi: 'Kaupunki',
    no: 'By'
});
map.set('orderEditorTitle',
{
    sv: 'Det här är alla ordrar',
    en: 'This is all orders',
    fi: 'Tässä on kaikki tilauksesi',
    no: 'Dette er alle bestillinger'
});
map.set('orderEditorSubTitle',
{
    sv: 'Det finns inte några ordrar',
    en: 'There arn\'t any orders',
    fi: 'Sinä et ole tehnyt tilausta',
    no: 'Det er ingen bestillinger'
});
map.set('myPageTitle',
{
    sv: 'Det här är din sida',
    en: 'This is your page',
    fi: 'Tämä on sinun sivusi',
    no: 'Dette er din side'
});
map.set('myPageSubTitle',
{
    sv: 'Här kan du se din samling och din profil',
    en: 'Here you can see your collection and profile',
    fi: 'Täällä voit nähdä kokoelmasi ja profiilisi',
    no: 'Her kan du se samlingen din og profilen din'
});
map.set('myPageUserInfo',
{
    sv: 'Din användarinformation',
    en: 'The user information',
    fi: 'Sinun käyttäjätietosi',
    no: 'Din brukerinformasjon'
});
map.set('edit',
{
    sv: 'Ändra',
    en: 'Edit',
    fi: 'Muokkaa',
    no: 'Endring'
});
map.set('cancel',
{
    sv: 'Ångra',
    en: 'Cancel',
    fi: 'Takaisin',
    no: 'Angre'
});
map.set('save',
{
    sv: 'Spara',
    en: 'Save',
    fi: 'Tallenna',
    no: 'Lagre'
});
map.set('peopleLike',
{
    sv: ' personer gillar detta',
    en: ' people like this',
    fi: ' henkilöä tykkää tästä',
    no: ' personer liker dette'
});
map.set('addCollection',
{
    sv: 'Lägg till i min samling',
    en: 'Add to My Collection',
    fi: 'Lisää kokoelmaani',
    no: 'Legg til samlingen min'
});
map.set('like',
{
    sv: 'Hjärta',
    en: 'Like',
    fi: 'Sydän',
    no: 'Hjerte'
});
map.set('inCollection',
{
    sv: 'I min samling',
    en: 'In My Collection',
    fi: 'Minun kokoelmassani',
    no: 'I samlingen min'
});
map.set('titleCoupon',
{
    sv: 'Kampanjkod',
    en: 'Coupon code',
    fi: 'Kamppanjakoodi',
    no: 'Kampanjekode'
});
map.set('subTitleCoupon',
{
    sv: 'Har du en kampanjkod?',
    en: 'Do you have a coupon code?',
    fi: 'Onko sinulla kampanjakoodi?',
    no: 'Har du en kampanjekode?'
});
map.set('select',
{
    sv: 'Välj',
    en: 'Select',
    fi: 'Valitse',
    no: 'Velg'
});
map.set('activate',
{
    sv: 'Aktivera',
    en: 'Activate',
    fi: 'Aktivoi',
    no: 'Aktiver'
});
map.set('remove',
{
    sv: 'Ta bort',
    en: 'Remove',
    fi: 'Poista',
    no: 'Fjerne'
});
map.set('homeHeartMugs',
{
    sv: 'Mest hjärtade muggarna',
    en: 'Most hearts for mugs',
    fi: 'Tykätyimmät mukit',
    no: 'De fleste hjerter for krus'
});
map.set('homePopularCharacters',
{
    sv: 'Mest populära karaktärerna',
    en: 'Most popular characters',
    fi: 'Suosituimmat hahmot',
    no: 'Mest populære karakterer'
});
map.set('homePopularMugs',
{
    sv: 'Mest köpta muggarna',
    en: 'Most bought mugs',
    fi: 'Ostetuimmat mukit',
    no: 'De fleste kjøpte krus'
});
map.set('footerText1',
{
    sv: 'Muggmania AB (Org.nr: 559108-5146) bedriver försäljning på moominhouse.se',
    en: 'Muggmania AB (Org.nr: 559108-5146) are selling on moominhouse.se',
    fi: 'Muggmania OY (Y-Tunnus 559108-5146) mukit ovat myynnissä myös moominhouse.se –kotisivulla',
    no: 'Muggmania AB (Org.nr: 559108-5146) driver salg på moominhouse.se'
});
map.set('footerText2',
{
    sv: 'Sidan är utvecklad av Erik Hedlund i samarbete med Muggmania',
    en: 'The page is developed by Erik Hedlund in collaboration with Muggmania',
    fi: 'Erik Hedlund on tehnyt kotisivut yhteistyössä Muggmanian kanssa',
    no: 'Siden er utviklet av Erik Hedlund i samarbeid med Muggmania'
});
map.set('shopTitle',
{
    sv: 'Butik',
    en: 'Shop',
    fi: 'Kauppa',
    no: 'Butikk'
});
map.set('shopSubTitle',
{
    sv: 'Här kan du handla dina favoriter. Alla muggar som säljs är utgångna vilket betyder att de inte längre går att köpa i butik, det ger dig ett unikt tillfälle att säkra just din älsklingsmugg. Kvaliteten på alla muggar är mycket hög, de flesta är i nyskick och all information om skicket finns under bilden.',
    en: 'Here you can buy your favorites. All mugs for sale are expired which means that you no longer can buy them in regular stores, this gives you a unique oppertunity to secure your absolut favorite mug. The quality of all mugs are very high, most are in mint condition and all information about them are bellow each picture.',
    fi: 'Täällä voit ostaa suosikkejasi. Kaikki mukit ovat jo poistuneet myynnistä, joten tässä sinulla on ainutlaatuinen tilaisuus hankkia lempimukisi. Mukit ovat korkealaatuisia, tarkka tieto mukin kunnosta löytyy jokaisen mukin kuvan alta.',
    no: 'Her kan du handle dine favoritter. Alle krus som selges er utgått på dato, noe som betyr at de ikke lenger kan kjøpes i butikk, det gir deg en unik mulighet til å sikre deg ditt favorittkrus. Kvaliteten på alle krusene er meget høy, de fleste er i ny stand og all informasjon om tilstanden er under bildet.'
});
map.set('buy',
{
    sv: 'Köp',
    en: 'buy',
    fi: 'Osta',
    no: 'Kjøpe'
});
map.set('inStorage',
{
    sv: 'st i lager',
    en: 'pcs in store',
    fi: 'varastossa',
    no: 'stk på lager'
});
map.set('moreInfoProduct',
{
    sv: 'Mer info om produkten',
    en: 'More info about product',
    fi: 'Lisätietoa tuotteesta',
    no: 'Mer info om produktet'
});
map.set('perfectCondition',
{
    sv: 'Perfekt skick',
    en: 'Perfect condition',
    fi: 'Uudenveroinen',
    no: 'Perfekt tilstand'
});
map.set('sticker',
{
    sv: 'Etikett',
    en: 'Sticker',
    fi: 'Tarra',
    no: 'Etikett'
});
map.set('completeOrder',
{
    sv: 'Slutför order',
    en: 'Complete order',
    fi: 'Viimeistele tilauksesi',
    no: 'Fullfør bestillinger'
});
map.set('method',
{
    sv: 'Metod',
    en: 'Method',
    fi: 'Tapa',
    no: 'Metode'
});
map.set('cost',
{
    sv: 'Kostnad',
    en: 'cost',
    fi: 'Kulut',
    no: 'Koste'
});
map.set('deliveryCompany',
{
    sv: 'Leveransföretag',
    en: 'Delivery company',
    fi: 'Kuljetusyritys',
    no: 'Leveringsfirma'
});
map.set('deliveryMethod',
{
    sv: 'Leveransmetod',
    en: 'Delivery method',
    fi: 'Toimitustapa',
    no: 'Leverings metode'
});
map.set('trackingCode',
{
    sv: 'Spårningskod',
    en: 'Tracking code',
    fi: 'seurantakoodi',
    no: 'Sporingskode'
});
map.set('description',
{
    sv: 'Beskrivning',
    en: 'Description',
    fi: 'Kuvaus',
    no: 'Beskrivelse'
});
map.set('emailPreference',
{
    sv: 'E-post preferenser',
    en: 'Email preference',
    fi: 'Sähköposti valinnat',
    no: 'E-postpreferanser'
});
map.set('articles',
{
    sv: 'Artiklar',
    en: 'Articles',
    fi: 'Artikkelit',
    no: 'Artikler'
});
map.set('information',
{
    sv: 'Information',
    en: 'Information',
    fi: 'Tietoa',
    no: 'Informasjon'
});
map.set('faq',
{
    sv: 'FAQ',
    en: 'FAQ',
    fi: 'Usein kysyttyjä kysymyksiä',
    no: 'FAQ'
});
map.set('aboutUs',
{
    sv: 'Om oss',
    en: 'About us',
    fi: 'Lisäätitoa meistä',
    no: 'Om oss'
});
map.set('contact',
{
    sv: 'Kontakt',
    en: 'Contact',
    fi: 'Yhteystiedot',
    no: 'Kontakt'
});
map.set('mustSupply',
{
    sv: 'Måste ange',
    en: 'Must supply',
    fi: 'Kirjoita',
    no: 'Må oppgi'
});
map.set('mustSupplyPaymentMethod',
{
    sv: 'Måste ange betalningsmetod',
    en: 'Must supply payment method',
    fi: 'Valitse maksutapa',
    no: 'Må spesifisere betalingsmåte'
});
map.set('signInToAddToCollection',
{
    sv: 'Ni måste logga in för att lägga till i er samling',
    en: 'You must sign in to add to your collection',
    fi: 'Kirjaudu sisään lisätäksesi tuotteita kokoelmaasi',
    no: 'Du må logge inn for å legge til samlingen din'
});
map.set('somethingWentWrong',
{
    sv: 'Något gick fel',
    en: 'Something went wrong',
    fi: 'Jotain meni väärin',
    no: 'Noe gikk galt'
});
map.set('mustSupplyDeliveryMethod',
{
    sv: 'Måste ange leveransmetod',
    en: 'Must supply delivery method',
    fi: 'Valitse toimitustapa',
    no: 'Må spesifisere leveringsmåte'
});
map.set('homeDescription',
{
    sv: 'En hemsida för alla muminsamlare. Läs information om alla karaktärer i mumindalen och om alla muminmuggar. Samt håll koll på din samling på ett smidigt sätt.',
    en: 'A website for all moomin collectors. Read information about all characters in Moomin valley and about all moomin mugs. And keep track of your own collection in a efficent way.',
    no: 'En nettside for alle mumiesamlere. Les informasjon om alle karakterene i Mummidalen og om alle Mummikrus. Og hold oversikt over samlingen din på en jevn måte.'
});
map.set('passwordReset',
{
    sv: 'Lösenord återställt!',
    en: 'Password reset!',
    fi: 'Salasana palautettu!',
    no: 'Reset passord'
});
map.set('signInNewPassword',
{
    sv: 'Ni kan nu logga in på ert konto med nya lösenordet här',
    en: 'You can now sign in on your account with the new password',
    fi: 'Täällä voit kirjaitua sisään uudella salasanalla',
    no: 'Du kan nå logge på kontoen din med det nye passordet her'
});
map.set('passwordCheckNoMatch',
{
    sv: 'Lösenordskontroll matchar inte lösenord',
    en: 'Password check doesn\'t match',
    fi: 'Väärä salasana',
    no: 'Passordkontroll samsvarer ikke med passord'
});
map.set('missingResetCode',
{
    sv: 'Saknar återställningskod',
    en: 'Missing reset code',
    fi: 'Salasanan palutuskoodi puuttuu',
    no: 'Mangler tilbakestillingskode'
});
map.set('supplyFirstAndLastname',
{
    sv: 'Ange för och efternamn',
    en: 'Supply first and lastname',
    fi: 'Etu ja sukunimi',
    no: 'Skriv inn for- og etternavn'
});
map.set('supplyCorrectEmail',
{
    sv: 'Måste ange en korrekt e-post',
    en: 'Must supply correct email',
    fi: 'Väärä sähköposti osoite',
    no: 'Skriv inn for- og etternavn'
});
map.set('chooseCharacter',
{
    sv: 'Välj vilken karaktär som ni tycker mest om',
    en: 'Choose which caracter you like',
    fi: 'Valitse suosikki hahmosi',
    no: 'Velg hvilken karakter du liker best'
});
map.set('characterTest',
{
    sv: 'https://www.moomin.com/sv/vilken-mumin-karaktar-ar-du/',
    en: 'https://www.moomin.com/en/which-moomin-are-you/',
    fi: 'https://www.moomin.com/fi/mika-muumihahmo-olet/',
    no: 'https://www.moomin.com/sv/vilken-mumin-karaktar-ar-du/'
});
map.set('orderConfirmed',
{
    sv: 'Order bekräftad!',
    en: 'Order confirmed!',
    fi: 'Tilaus vahvistettu!',
    no: 'Ordre bekreftet!'
});
map.set('thanksPurchase',
{
    sv: 'Tack för ert köp!',
    en: 'Thanks for your purchase!',
    fi: 'Kiitos ostoksesta!',
    no: 'Takk for kjøpet!'
});
map.set('getEmail',
{
    sv: 'Ni kommer få ett mail till er e-postadress',
    en: 'You will get an email to you email',
    fi: 'Saatte sähköpostin osoitteeseen',
    no: 'Du vil motta en e-post til din e-postadresse'
});
map.set('followOrder',
{
    sv: 'Ni kan alltid följa ordern via er sida',
    en: 'You can follow the order on your page',
    fi: 'Voitte seurata lähetystä teidän sivulta',
    no: 'Du kan alltid følge bestillingen via din side'
});
map.set('emailResetPassword',
{
    sv: 'Ni kommer få en e-post där ni kan återställa ert lösenord',
    en: 'You will get an email where you can reset your password',
    fi: 'Saatte sähköpostin salasanan vaihtoa varten',
    no: 'Du vil motta en e-post hvor du kan tilbakestille passordet ditt'
});
map.set('hereResetPassword',
{
    sv: 'Här kan du återställa ditt lösenord.',
    en: 'Here you can reset your password',
    fi: 'Täällä voit',
    no: 'Her kan du tilbakestille passordet ditt.'
});
map.set('readFavoriteCharacter',
{
    sv: 'Här kan ni läsa om era favoritkaraktärer.',
    en: 'Here you can read about your favorite character.',
    fi: 'Täällä voitte lukea lempihahmoistanne.',
    no: 'Her kan du lese om favorittkarakterene dine.'
});
map.set('shopFavorite',
{
    sv: 'Här kan ni handla era favorit muminmuggar.',
    en: 'Here you can shop your favorite moomin mugs.',
    fi: 'Täällä voitte ostaa lempimukinne.',
    no: 'Her kan du kjøpe dine favoritt mummikrus.'
});
map.set('validateEmail',
{
    sv: 'Här validerar du din e-post.',
    en: 'Here you can validate you email',
    fi: 'Vahvista sähköpostiosoitteesi',
    no: 'Her validerer du e-posten din.'
});
map.set('yourShoppingCart',
{
    sv: 'Det här är din kundvagn.',
    en: 'This is your shopping cart',
    fi: 'Tämä on ostoskorisi',
    no: 'Dette er handlekurven din.'
});
map.set('readProducts',
{
    sv: 'Här kan ni läsa allt om olika muminmuggar och hitta era favoriter.',
    en: 'Here you can read about all different moomin mugs and find your favorite',
    fi: 'Täällä voitte lukea muumimukeista ja löytää suosikkinne.',
    no: 'Her kan du lese alt om ulike Mummikrus og finne dine favoritter.'
});
map.set('yourOrders',
{
    sv: 'Dina ordrar',
    en: 'Your orders',
    fi: 'Tilauksesi',
    no: 'Dine ordre'
});
map.set('seeOrders',
{
    sv: 'Här kan du se alla dina orders.',
    en: 'Here you can see all your orders',
    fi: 'Täällä näet kaikki tilauksesi',
    no: 'Her kan du se alle dine bestillinger'
});
map.set('chooseNewPassword',
{
    sv: 'Välj nytt lösenord',
    en: 'Choose new password',
    fi: 'Vaihda salasana',
    no: 'Velg et nytt passord'
});
map.set('hereChooseNewPassword',
{
    sv: 'Här kan du välja nytt lösenord.',
    en: 'Here you can choose a new password',
    fi: 'Täällä voit vaihtaa salasanan',
    no: 'Her kan du velge et nytt passord.'
});
map.set('thisIsYourPage',
{
    sv: 'Detta är din sida.',
    en: 'This is your page.',
    fi: 'Tämä on sinun sivusi',
    no: 'Dette er din side.'
});
map.set('yourCollection',
{
    sv: 'Din samling',
    en: 'Your collection',
    fi: 'Kokoelmasi',
    no: 'Din samling'
});
map.set('seeYourCollection',
{
    sv: 'Här kan du se alla muminmuggar som du har i din samling',
    en: 'Here you can see all moominmugs in your collection',
    fi: 'Täällä voit nähdä kaikki kokoelmasi mukit',
    no: 'Her kan du se alle mummikrusene du har i samlingen din'
});
map.set('shareLink',
{
    sv: 'Dela den här länken',
    en: 'Share this link',
    fi: 'Jaa linkki',
    no: 'Del denne linken'
});
map.set('followOrder',
{
    sv: 'Följ order',
    en: 'Follow order',
    fi: 'Seuraa lähetystä',
    no: 'Følg ordre'
});
map.set('partSum',
{
    sv: 'Delsumma',
    en: 'Part sum',
    fi: 'Välisumma',
    no: 'Delsum'
});
map.set('payment-selector.extra.1',
{
    sv: 'Kostnad extra ',
    en: 'Extra cost ',
    fi: 'Lisämaksu ',
    no: 'Kostnad ekstra '
});
map.set('payment-selector.extra.2',
{
    sv: ' % av totalbelopp',
    en: ' % of total cost',
    fi: ' %',
    no: ' % av totalbeløpet'
});
map.set('shopping-cart.error.1',
{
    sv: 'Fel antal produkter, order uppdaterad enligt nuvarande lager',
    en: 'Wrong number of products, updating order according to current stock',
    fi: 'Väärä lukumäärä, tilaus päivitetty ja tuote loppui varastosta',
    no: 'Feil antall produkter, bestilling oppdatert i henhold til gjeldende lagerbeholdning'
});
map.set('search-filter.filter',
{
    sv: 'Filter',
    en: 'Filter',
    fi: 'Suodatin',
    no: 'Filter'
});
map.set('search-filter.search',
{
    sv: 'Sök',
    en: 'Search',
    fi: 'Hae',
    no: 'Søk'
});
map.set('search-filter.reset',
{
    sv: 'Ta bort filter',
    en: 'Reset all filters',
    fi: 'Poista kaikki valinnat',
    no: 'Tilbakestill alle filtre'
});
map.set('home.identify',
{
    sv: 'personer identifierar sig som',
    en: 'persons identifys as',
    fi: 'ihmistä tunnistaa itsensä',
    no: 'personer identifiserer seg som'
});
map.set('collection.add',
{
    sv: 'Lägg till',
    en: 'Add',
    fi: 'Lisää',
    no: 'Legg til'
});
map.set('collection.no-sticker',
{
    sv: 'Ej etikett',
    en: 'No sticker',
    fi: 'Ilman tarraa',
    no: 'Ingen etikette'
});
map.set('collection.purchase-price',
{
    sv: 'Inköpspris',
    en: 'Purchase price',
    fi: 'Ostohinta',
    no: 'Kjøpesum'
});
map.set('collection.estimated-value',
{
    sv: 'Estimerat värde',
    en: 'Estimated value',
    fi: 'Arvioitu arvo',
    no: 'Estimert verdi'
});
map.set('collection.total-purchase-price',
{
    sv: 'Totalt inköpspris',
    en: 'Total purchase price',
    fi: 'Ostohinta',
    no: 'Total kjøpesum'
});
map.set('collection.total-estimated-value',
{
    sv: 'Totalt estimerat värde',
    en: 'Total estimated value',
    fi: 'Arvioitu kokonaisarvo',
    no: 'Total estimert verdi'
});
map.set('collection.collected',
{
    sv: 'Samlade',
    en: 'Collected',
    fi: 'Kerätty',
    no: 'Samlet'
});
map.set('collection.with-sticker',
{
    sv: 'Med etikett',
    en: 'With sticker',
    fi: 'Tarrallinen',
    no: 'Med etikett'
});
map.set('collection.choose-currency',
{
    sv: 'Välj valuta',
    en: 'Choose currency',
    fi: 'Valitse valuutta',
    no: 'Velg valuta'
});
map.set('home.links.collection',
{
    sv: 'Skapa och fyll i din egen samling',
    en: 'Create your own collection',
    fi: 'Luo oma kokoelmasi',
    no: 'Lag og fyll ut din egen samling'
});
map.set('home.links.products',
{
    sv: 'Läs om alla muminmuggar',
    en: 'Read about all moominmugs',
    fi: 'Lue kaikista muumimukeista',
    no: 'Les om alle Mummikrus'
});
map.set('home.links.buy',
{
    sv: 'Köp dina favoriter',
    en: 'Buy your favorites',
    fi: 'Osta suosikkisi',
    no: 'Kjøp dine favoritter'
});
map.set('home.links.characters',
{
    sv: 'Läs om alla karaktärer i Mumindalen',
    en: 'Read about all characters in Moomin valley',
    fi: 'Lue kaikista Muumilaakson hahmoista',
    no: 'Les om alle karakterene i Mummidalen'
});
map.set('collection.currency-selection',
{
    sv: 'Välj din valuta',
    en: 'Choose your curreny',
    fi: 'Valitse valuuttasi',
    no: 'Velg din valuta'
});

export function LanguagePlugin(Vue: typeof _Vue, options?: any): void {
    Vue.prototype.$text = function text(keyword: string): string {
            return this.$store.getters.getLanguage(map.get(keyword));
        };
}
